/*
 * <routine-steps> — tabbed routine walkthrough (desktop list + mobile 4-up tabs share one markup).
 * Markup contract: [role=tab][data-step-tab="i"], [role=tabpanel][data-step-panel="i"], optional [data-step-progress].
 * Arrow keys / Home / End move between tabs.
 */
if (!customElements.get('routine-steps')) {
  class RoutineSteps extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-step-tab]')];
      this.panels = [...this.querySelectorAll('[data-step-panel]')];
      this.progress = this.querySelector('[data-step-progress]');
      this.onClick = (event) => {
        const tab = event.target.closest('[data-step-tab]');
        if (tab) this.select(Number(tab.dataset.stepTab));
      };
      this.onKey = (event) => {
        const current = this.tabs.findIndex((tab) => tab === document.activeElement);
        if (current === -1) return;
        let next = current;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (current + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (current - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.select(next, true);
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
    }

    select(index, focus = false) {
      this.tabs.forEach((tab, i) => {
        const on = i === index;
        tab.setAttribute('aria-selected', String(on));
        tab.tabIndex = on ? 0 : -1;
        if (on && focus) tab.focus();
      });
      this.panels.forEach((panel, i) => {
        panel.hidden = i !== index;
      });
      if (this.progress) this.progress.style.width = `${((index + 1) / this.tabs.length) * 100}%`;
    }
  }
  customElements.define('routine-steps', RoutineSteps);
}
